import { useState, useEffect } from "react";
import ContentHeader from "../ContentHeader";
import FormField, { STYLE } from "components/FormField";
import Checkbox from "components/Checkbox";
import {formatPhoneNumber} from '../helpers'

import styles from "./DriverInfo.module.scss";

const DriverInfo = ({ fetchData, updateData, errors }) => {
  const { driverNameErr,driverPhoneErr } = errors
  const [d1name, setD1name] = useState(null)
  const [d1Phone, setD1phone] = useState(null)
  const [d2name, setD2name] = useState(null)
  const [d2Phone, setD2phone] = useState(null)
  const [TCA, setTCA] = useState(false)
  const [TWIC, setTWIC] = useState(false)
  const [hazmat, setHazmat] = useState(false)
  const [usCitizen, setUsCitizen] = useState(false)
  const [crossingBorder, setCrosingBorder] = useState(false)

  // update driver 1
  useEffect(()=> {

    updateData('drivers', 0, {
      name: d1name,
      phone_number: d1Phone ?`+1${d1Phone}` : null,
      tsa_certificate: TCA,
      twic_certificate: TWIC,
      hazmat_certificate: hazmat,
      can_cross_us_can_border: crossingBorder,
      us_citizen: usCitizen
  });
  }, [ d1name, d1Phone, TCA,TWIC, hazmat, usCitizen, crossingBorder])

  // Update driver 2
  useEffect(()=> {
    updateData('drivers', 1, {
      name: d2name,
      phone_number: d2Phone ?`+1${d2Phone}` : null, 
  });
  }, [ d2name, d2Phone ])

  const handleChange = (event) => {
    const { value } = event.target;
    const formattedValue = formatPhoneNumber(value)
    
    setD1phone(formattedValue);
  };
  const handleChangeD2 = (event) => {
    const { value } = event.target;
    const formattedValue = formatPhoneNumber(value)
    
    setD2phone(formattedValue);
  };

  return (
    <>
      <div className={styles.wrapper}>
        <ContentHeader
          title="Driver Info"
          className={styles.header}
        />
        <div className={styles.group}>
          <div className={styles.group_item}>
            <label className={styles.label}>
              Driver Name 1 <span className={styles.red}>*</span>
            </label>
            <FormField
              value={d1name}
              style={STYLE.FORM}
              onChange={(e) => setD1name(e.target.value)}
              error={driverNameErr ? true : false}
              errorMessage={driverNameErr}
              className={styles.errorMessage}
            />
          </div>
          <div className={styles.group_item}>
            <label className={styles.label}>
              Driver Phone Number 1 <span className={styles.red}>*</span>
            </label>
              <FormField
              value={d1Phone}
              style={STYLE.FORM_PHONE}
              onChange={handleChange}
              error={driverPhoneErr ? true : false}
              errorMessage={driverPhoneErr}
              className={styles.errorMessage}
            />
            <p className={styles.before}>+1</p>
          </div>
          <div className={styles.group_item}>
            <div className={styles.checkbox}>
              <Checkbox
                id="TCA"
                label="TCA Certified"
                value={TCA}
                onChange={() => setTCA(!TCA)}
                className={styles.checkbox}
              />
            </div>

            <div className={styles.checkbox}>  
              <Checkbox
                id="TWIC"
                label="TWIC Certified"
                value={TWIC}
                onChange={() => setTWIC(!TWIC)}
                className={styles.checkbox}
              />
            </div>
            
          
            <div className={styles.checkbox}>  
              <Checkbox
                id="HazMat"
                label="Hazmat Certified"
                value={hazmat}
                onChange={() => setHazmat(!hazmat)}
                className={styles.checkbox}
              />
            </div>
            
          </div>
          <div className={styles.group_item}>
            
            <div className={styles.checkbox}>              
              <Checkbox
                id="Us"
                label="US Citizen"
                value={usCitizen}
                onChange={() => setUsCitizen(!usCitizen)}
                className={styles.checkbox}
              />
            </div>
            

            <div className={styles.checkbox}>  
              <Checkbox
                id="border"
                label="Crossing Border"
                value={crossingBorder}
                onChange={() => setCrosingBorder(!crossingBorder)}
                className={styles.checkbox}
              />
            </div>
          </div>
        </div>
        <div className={styles.group}>
          <div className={styles.group_item}>
            <label className={styles.label}>
              Driver Name 2
            </label>
            <FormField
              value={d2name}
              style={STYLE.FORM}
              onChange={(e) => setD2name(e.target.value)}
            />
          </div>
          <div className={styles.group_item}>
            <label className={styles.label}>
              Driver Phone Number 2
            </label>
            <FormField
              value={d2Phone}
              style={STYLE.FORM_PHONE}
              onChange={handleChangeD2}
            />
            <p className={styles.before}>+1</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DriverInfo;
